// Mirrors backend/app/routes/vacant_land.py pricing (server recalculates the charged amount).
export const GUARANTEE = 'Photos delivered within 24 hours. Full refund if weather or FAA restrictions cancel the shoot.';
export const LOT_LINE_NOTE = 'Boundary/lot-line overlays are approximate, not a survey.';
export const VIDEO_ADDON = 125;

export const LAND_BANDS = [
  { key: 'under_1', label: 'Under 1 acre', max: 1, inside: 75, outside: 100, lotLines: false, below: true },
  { key: '1_to_2_5', label: '1 to 2.5 acres', max: 2.5, inside: 135, outside: 160, lotLines: true },
  { key: '2_5_to_5', label: 'Over 2.5 to 5 acres', max: 5, inside: 160, outside: 185, lotLines: true },
  { key: '5_to_10', label: 'Over 5 to 10 acres', max: 10, inside: 185, outside: 210, lotLines: true },
  { key: '10_to_40', label: 'Over 10 to 40 acres', max: 40, inside: 225, outside: 250, lotLines: true },
  { key: '40_to_160', label: 'Over 40 to 160 acres', max: 160, inside: 300, outside: 325, lotLines: true },
];

export const bandFor = (acres) => {
  if (!(acres > 0)) return null;
  if (acres < 1) return LAND_BANDS[0];
  return LAND_BANDS.slice(1).find((b) => acres <= b.max) || { key: 'over_160', label: 'Over 160 acres', quote: true, lotLines: true };
};

export const LOCATION_LABELS = { inside: 'Inside Kingman city limits', outside: 'Outside city limits', not_sure: 'Not sure — charged outside rate' };

export const landPrice = (form) => {
  const band = bandFor(parseFloat(form.acreage));
  if (!band || band.quote) return { band, quote: !!band?.quote, base: 0, video: 0, total: 0 };
  const base = form.location === 'inside' ? band.inside : band.outside;
  const video = form.addVideo ? VIDEO_ADDON : 0;
  return { band, quote: false, base, video, total: base + video };
};

export const EMPTY_LAND_FORM = {
  parcelAddress: '', apn: '', city: '', zipCode: '', acreage: '', location: '', addVideo: false,
  preferredDate: '', accessNotes: '',
};
